<template>
  <b-modal
    size="xl"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    id="topics-modal"
    :visible="showModal"
    @hidden="closeModal"
  >
    <div style="height: calc(100vh - 180px)">
      <div class="d-flex align-items-center w-100">
        <div style="width: 40%" class="st-select-test">Select Test</div>
        <div
          class="d-flex align-items-center w-60"
          :class="
            checkTopicSelected
              ? 'justify-content-between'
              : 'justify-content-end'
          "
        >
          <div
            v-if="checkTopicSelected"
            style="margin-left: 36px"
            class="w-100 text-truncate"
          >
            <span id="topic-name" href="#" class="st-select-test w-100">
              {{ selectedTopic.name }}
            </span>
            <template v-if="selectedTopic.name.length > 50">
              <b-tooltip target="topic-name" placement="bottomleft">
                {{ selectedTopic.name }}
              </b-tooltip>
            </template>
          </div>
          <div
            @click="closeModal"
            class="st-xCancel d-flex justify-content-between ml-5"
          >
            <img
              class="rotate-on-hover"
              src="../../../assets/img/selecttest/st-crossicon.svg"
              alt=""
            />
          </div>
        </div>
      </div>
      <hr />

      <b-row>
        <b-col cols="5">
          <div style="height: calc(100vh - 290px)">
            <div class="st-search-bar-topics">
              <img
                class="st-searchicon position-absolute pl-3 py-2 mt-1"
                src="../../../assets/img/search-bar-icon.svg"
                alt=""
              />
              <b-form-input
                v-model.trim="searchTopic"
                class="st-search-input"
                placeholder="Search Topics"
                type="search"
                debounce="500"
                @update="resetTopicData(), getTopics(true)"
              ></b-form-input>
            </div>

            <b-overlay :show="topicLoading" class="h-90">
              <div class="topics-container mt-2" @scroll="onScrollTopics">
                <template v-if="topics.length > 0">
                  <div
                    class="
                      st-topic-cards
                      pointer
                      mb-2
                      d-flex
                      justify-content-between
                      align-items-center
                      position-relative
                    "
                    v-for="(topic, index) in topics"
                    :key="index"
                    @click="selectTopic(topic)"
                    :style="
                      isSelectedTopic(topic.topicID)
                        ? 'background: #20639B;'
                        : 'background: #FFFFFF;'
                    "
                  >
                    <div
                      v-if="isSelectedTopic(topic.topicID)"
                      class="st-createjob-cardline"
                    ></div>

                    <div
                      class="w-90 text-truncate"
                      :style="
                        isSelectedTopic(topic.topicID)
                          ? 'color: #FFFFFF;'
                          : 'color: #272727;'
                      "
                    >
                      <span
                        class="st-topic-name"
                        :id="index"
                        :style="
                          isSelectedTopic(topic.topicID)
                            ? 'color: #FFFFFF;'
                            : 'color: #272727;'
                        "
                      >
                        {{ topic.name }}
                      </span>

                      <template v-if="topic.name.length > 45">
                        <b-tooltip :target="'' + index" placement="topleft">
                          {{ topic.name }}
                        </b-tooltip>
                      </template>
                    </div>
                    <div
                      class="topic-autogenerate"
                      v-if="topic.name == 'AutoGenerate'"
                    >
                      (Autogenerate)
                    </div>
                    <div
                      v-if="isSelectedTopic(topic.topicID) && !testLoading"
                      class="st-topic-name-text"
                    >
                      {{ tests.length }}
                    </div>
                  </div>

                  <div
                    style="margin: auto"
                    v-if="showTopicLoader"
                    class="d-flex justify-content-center mb-3"
                  >
                    <span></span>
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                </template>

                <template
                  v-else-if="
                    !topicLoading &&
                    searchTopic.length > 0 &&
                    topics.length === 0
                  "
                >
                  <div
                    class="
                      st-topic-cards
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <span class="selected-text">
                      No matching results for &nbsp;<span
                        class="font-weight-bold"
                        >"{{ searchTopic }}"</span
                      >.</span
                    >
                  </div>
                </template>

                <template v-else-if="!topicLoading">
                  <div
                    class="
                      st-topic-cards
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <span class="selected-text">No Topics</span>
                  </div>
                </template>
              </div>
            </b-overlay>
          </div>
        </b-col>
        <b-col cols="7">
          <template v-if="checkTopicSelected">
            <b-overlay :show="testLoading">
              <div class="h-100">
                <div>
                  <div class="st-info-box d-flex align-items-center pl-2">
                    <img
                      src="../../../assets/img/selecttest/st-exclaim.svg"
                      alt=""
                    />
                    <span class="st-info-text ml-2"
                      >The test which has sections in it will be shown in the
                      list.</span
                    >
                  </div>

                  <div class="st-search-bar-topics mt-3">
                    <img
                      class="st-searchicon position-absolute pl-3 py-2 mt-1"
                      src="../../../assets/img/search-bar-icon.svg"
                      alt=""
                    />
                    <b-form-input
                      v-model.trim="searchTests"
                      @update="searchForTests"
                      debounce="500"
                      class="st-search-input"
                      placeholder="Search Tests"
                      type="search"
                    ></b-form-input>
                  </div>
                  <hr class="st-hrizon-line ml-1" />
                  <div class="d-flex justify-content-between p-2 mx-1 mb-2">
                    <div class="text-center pff-checkbox">
                      <b-form-checkbox
                        v-model="selectAll"
                        @change="selectAllTests"
                        :disabled="testList.length == 0"
                        >Select All</b-form-checkbox
                      >
                    </div>
                    <div class="tp-bluetxt">
                      Selected Tests:&nbsp;{{
                        displayCount(selectTests.length)
                      }}
                    </div>
                  </div>
                  <div class="tests-list" @scroll="onScrollTest">
                    <template v-if="tests.length > 0">
                      <div
                        class="
                          st-test-box
                          d-flex
                          align-items-center
                          justify-content-between
                          p-2
                          mx-1
                          mb-2
                        "
                        v-for="(test, index) in tests"
                        :key="index"
                      >
                        <div class="pff-checkbox pt-1">
                          <b-form-checkbox
                            v-model="selectTests"
                            :value="{
                              active: test.active,
                              testID: test.testID,
                              name: test.name,
                              marks: test.marks,
                              numberOfSections: test.numberOfSections,
                              difficultyLevel: test.difficultyLevel,
                              autoCorrection: test.autoCorrection,
                              noOfQuestions: test.noOfQuestions,
                              allSectionsHaveQuestions:
                                test.allSectionsHaveQuestions,
                              topicID: selectedTopic.topicID,
                              topicName: selectedTopic.name,
                            }"
                            @input="checkSelectAll"
                          ></b-form-checkbox>
                        </div>

                        <div
                          style="width: 44%"
                          class="st-selected-text pr-5 text-truncate"
                        >
                          {{ test.name }}
                        </div>

                        <div class="d-flex flex-column w-20">
                          <span class="sections-text">No of Questions</span>
                          <span
                            class="selected-text pl-1"
                            style="color: #84a3fe"
                            >{{ test.noOfQuestions }}</span
                          >
                        </div>

                        <div class="d-flex flex-column" style="width: 13%">
                          <span class="sections-text">Sections</span>
                          <span
                            class="selected-text pl-1"
                            style="color: #84a3fe"
                            >{{ test.numberOfSections }}</span
                          >
                        </div>

                        <div class="d-flex flex-column" style="width: 13%">
                          <span class="sections-text">Marks</span>
                          <span class="selected-text" style="color: #84a3fe">{{
                            getMarks(test.marks)
                          }}</span>
                        </div>
                      </div>
                      <div
                        style="margin: auto"
                        v-if="showTestLoader"
                        class="d-flex justify-content-center mb-3"
                      >
                        <b-spinner label="Loading..."></b-spinner>
                      </div>
                    </template>

                    <template
                      v-else-if="
                        !testLoading &&
                        searchTests.length > 0 &&
                        tests.length === 0
                      "
                    >
                      <div
                        class="
                          tests-box
                          d-flex
                          align-items-center
                          justify-content-center
                          p-3
                        "
                      >
                        <span class="selected-text">
                          No matching results for &nbsp;<span
                            class="font-weight-bold"
                            >"{{ searchTests }}"</span
                          >.</span
                        >
                      </div>
                    </template>

                    <template v-else-if="!testLoading">
                      <div
                        class="
                          tests-box
                          d-flex
                          align-items-center
                          justify-content-center
                          p-3
                        "
                      >
                        <span class="selected-text">No Tests</span>
                      </div>
                    </template>
                  </div>

                  <div
                    class="d-flex align-items-center justify-content-end mt-4"
                  >
                    <b-button
                      class="addbtn pr-4 pl-4"
                      :disabled="selectTests.length === 0"
                      @click="addTests"
                    >
                      Add Test
                    </b-button>
                  </div>
                </div>
              </div>
            </b-overlay>
          </template>

          <template v-else>
            <div
              class="
                h-100
                d-flex
                flex-column
                align-items-center
                justify-content-center
              "
            >
              <img
                src="../../../assets/img/selecttest/selecttest-JD.svg"
                alt=""
              />
              <span class="mt-4 test-selection-text"
                >Please select any tests from the topics list on the left to add
                them to this job</span
              >
            </div>
          </template>
        </b-col>
      </b-row>

      <div class="st-end-small-container position-absolute bluebtn">
        <div class="d-flex justify-content-end mt-3">
          <b-button
            class="acs-cancelBtn-modal pointer mr-3 mb-3"
            @click="closeModal"
            >Cancel</b-button
          >

          <b-button
            class="acs-addBtn-modal pointer mb-3 mr-3"
            :disabled="selectTests.length === 0"
            @click="addTests"
            >Select Test</b-button
          >
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { getTopic, getTest } from "../../../utils/apiFunctions";
export default {
  props: {
    showModal: Boolean,
    selectedTests: {
      type: Array,
      default: () => {
        return [];
      },
    },
    selectedTestIds: {
      type: Set,
    },
  },
  data() {
    return {
      showTopicLoader: false,
      testLoading: false,
      topicLoading: false,
      showTestLoader: false,
      selectAll: false,
      topics: [],
      tests: [],
      testList: [],
      selectTests: [],
      selectedTopic: {},
      searchTests: "",
      searchTopic: "",
      totalTest: 0,
      testPageEnd: 0,
      testPage: 0,
      topicPage: 0,
      topicPageEnd: 0,
      totalTopic: 0,
      count: 10,
    };
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.selectTests = [...this.selectedTests];
        this.getTopics(true);
      }
    },
  },
  computed: {
    checkTopicSelected() {
      return Object.keys(this.selectedTopic).length > 0;
    },
  },
  methods: {
    displayCount(data) {
      if (data < 9) {
        return "0" + data;
      } else {
        return data;
      }
    },
    searchForTests() {
      this.resetTestData();
      this.getTests(true);
      this.getTestsForSelectAll();
    },
    resetTopicData() {
      this.totalTopic = 0;
      this.topicPageEnd = 0;
      this.topicPage = 0;
      this.topics = [];
    },
    resetTestData() {
      this.totalTest = 0;
      this.testPageEnd = 0;
      this.testPage = 0;
      this.tests = [];
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    onScrollTopics(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) + 1 >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (this.checkbetween(this.topicPageEnd, 0, this.totalTopic)) {
          this.topicPage++;
          this.getTopics();
        }
      }
    },
    onScrollTest(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) + 1 >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (this.checkbetween(this.testPageEnd, 0, this.totalTest)) {
          this.testPage++;
          this.getTests();
        }
      }
    },
    isSelectedTopic(topicID) {
      return this.selectedTopic.topicID === topicID;
    },
    closeModal() {
      this.selectTests = [];
      this.tests = [];
      this.topics = [];
      this.searchTests = "";
      this.searchTopic = "";
      this.selectedTopic = {};
      this.resetTestData();
      this.resetTopicData();
      this.$emit("close-topics-modal");
    },
    selectTopic(topic) {
      this.selectedTopic = topic;
      this.searchTests = "";
      this.resetTestData();
      this.getTests(true);
      this.getTestsForSelectAll();
    },
    addTests() {
      this.$emit("add-tests", this.selectTests);
      this.closeModal();
    },
    getMarks(marks) {
      let index = marks.toString().indexOf(".");
      if (index !== -1) {
        let decimal = marks.toString().split(".");
        if (decimal[1].length > 3) {
          return decimal[0] + "." + decimal[1].slice(0, 3);
        }
      }
      return marks;
    },
    async getTopics(showMainLoader) {
      try {
        if (showMainLoader) {
          this.topicLoading = true;
        }
        let payload = {
          searchQuery: this.searchTopic,
          sortBy: "createdAt",
          order: "-1",
          type: "1",
          page: this.topicPage,
          count: 15,
        };
        const res = await getTopic(payload);
        if (res.status == 200) {
          if (this.topicPage == 0) {
            this.topics = res.data.data.topicIDs;
          } else {
            this.topics = [...this.topics, ...res.data.data.topicIDs];
          }
          this.showTopicLoader = res.data.data.total !== res.data.data.pageEnd;
          this.totalTopic = res.data.data.total;
          this.topicPageEnd = res.data.data.pageEnd;
        }
        this.topicLoading = false;
      } catch (error) {
        this.topicLoading = false;
        console.error(error);
      }
    },

    checkSelectAll() {
      // If testList is empty, set selectAll to false
      if (this.testList.length === 0) {
        this.selectAll = false;
        return;
      }

      // Create a set of test IDs from selectTests for fast lookup
      const selectedTestIDs = new Set(
        this.selectTests.map((test) => test.testID)
      );

      // Check if every test in testList is in selectedTestIDs
      this.selectAll = this.testList.every((test) =>
        selectedTestIDs.has(test.testID)
      );
    },

    selectAllTests() {
      if (this.selectAll) {
        // Create a Set for quick lookup
        const selectedTestIDs = new Set(
          this.selectTests.map((test) => test.testID)
        );

        // Add all tests from tests to selectTests if they are not already present
        this.tests.forEach((test) => {
          if (!selectedTestIDs.has(test.testID)) {
            this.selectTests.push({
              active: test.active,
              testID: test.testID,
              name: test.name,
              marks: test.marks,
              numberOfSections: test.numberOfSections,
              difficultyLevel: test.difficultyLevel,
              autoCorrection: test.autoCorrection,
              noOfQuestions: test.noOfQuestions,
              allSectionsHaveQuestions: test.allSectionsHaveQuestions,
              topicID: this.selectedTopic.topicID,
              topicName: this.selectedTopic.name,
            });
          }
        });
      } else {
        // Remove all tests from tests in selectTests
        this.selectTests = this.selectTests.filter(
          (test) =>
            !this.tests.some(
              (testListItem) => test.testID === testListItem.testID
            )
        );
      }
    },

    async getTestsForSelectAll() {
      try {
        let payload = {
          topicID: this.selectedTopic.topicID,
          searchQuery: this.searchTests,
        };
        const response = await getTest(payload);
        if (response.status == 200) {
          this.testList = response.data.data.testIDs;
          this.checkSelectAll();
        }
      } catch (error) {
        this.testLoading = false;
        console.error(error);
      }
    },

    async getTests(showMainLoader) {
      try {
        if (showMainLoader) {
          this.testLoading = true;
        }
        let payload = {
          topicID: this.selectedTopic.topicID,
          searchQuery: this.searchTests,
          sortBy: "updatedAt",
          order: "1",
          type: "1",
          page: this.testPage,
          count: this.count,
        };
        const response = await getTest(payload);
        if (response.status == 200) {
          if (this.testPage == 0) {
            this.tests = response.data.data.testIDs;
          } else {
            this.tests = [...this.tests, ...response.data.data.testIDs];
          }
          this.showTestLoader =
            response.data.data.total !== response.data.data.pageEnd;

          this.totalTest = response.data.data.total;
          this.testPageEnd = response.data.data.pageEnd;
          let index = 0;
          while (index < this.tests.length) {
            if (this.selectedTestIds.has(this.tests[index].testID)) {
              this.tests.splice(index, 1);
            } else {
              index++;
            }
          }
        }
        this.testLoading = false;
      } catch (error) {
        this.testLoading = false;
        console.error(error);
      }
    },
  },
};
</script>

<style>
.st-select-tests {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #000000;
}

.col-6 {
  flex: 0 0 49%;
}

.st-topic-cards {
  padding: 13px;
  border: 1px solid rgba(140, 140, 140, 0.33);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
}

.st-test-box {
  background: #fcfcfc;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}

.st-search-bar-topics .st-search-input {
  padding: 9px 38px;
  background: rgba(114, 115, 142, 0.08);
  border-radius: 12px;
}

.st-topic-containers {
  background: #f3f3f3;
  border-radius: 6px;
}

.st-info-text {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #20639b;
}

.st-topic-name {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #272727;
}

.st-selected-text {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #272727;
}

.st-search-bar {
  background: #fcfcfc;
  box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
  border-radius: 5px;
}

label[for="st-selectAllCheckbox"] {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #3a3c40;
}

.st-topics-name {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #272727;
}

.st-end-small-container {
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  border-top: 1px solid #d7d7d7;
  border-radius: 0px 0px 12px 12px;
}

.st-tp-bluetxt {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #20639b;
}
.sections-text {
  color: #696969;
  font-size: 13px;
  font-weight: 400;
}

.tests-box {
  border-radius: 5px;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px rgba(196, 196, 196, 0.5);
}

.tests-list {
  height: calc(100vh - 447px);
  overflow: auto;
}

.test-selection-text {
  font-size: 12px;
  color: #696969;
}

.selected-text {
  color: #545454;
  font-size: 14px;
  font-weight: 500;
  word-break: break-all;
}

.info-text {
  color: #72738e;
  font-size: 12px;
  font-weight: 400;
}

.info-box {
  width: 420px;
  height: 38px;
  background: #fff1c3;
  box-shadow: 0px 0px 0px 0px rgba(86, 86, 86, 0.13);
}

.vertical-bar {
  height: 100%;
  border-radius: 0px 10px 10px 0px;
  border: 0.5px solid #adaaaa;
  background: #fff;
}

.select-tests {
  color: #72738e;
  font-size: 14px;
  font-weight: 600;
}

.search-bar-popup-topics {
  position: relative;
  width: 100%;
}

.search-bar-popup-topics .search-input {
  height: 34px;
  background: #ffffff;
  border: 0.5px solid #c4c4c4;
  box-sizing: border-box;
  box-shadow: inset 0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0 30px !important;
  width: 100%;
}

.search-bar-popup-topics .searchicon {
  position: absolute;
  top: 10px;
  left: 10px;
}

.topics-container {
  background: #f3f3f3;
  height: calc(100vh - 330px) !important;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 15px;
}

.topic-cards {
  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 15px;
}

.topic-name {
  font-size: 14px;
  font-weight: 500;
}

.topic-autogenerate {
  color: #747474;
  font-size: 0.75rem;
  font-weight: 400;
}

.st-createjob-cardline {
  position: absolute;
  left: 1px;
  height: 89%;
  width: 4px;
  border-radius: 50px;
  background: #f6f6f6;
}

.st-topic-name-text {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
}
</style>
